module.exports = __webpack_public_path__ + "static/media/icon-commerce.02bc9332.svg";